import React from "react";
import horizontalLine from "../../../assets/images/bingo/horizontalLine.png";
import verticalLine from "../../../assets/images/bingo/verticalLine.png";
import diagonalLine1 from "../../../assets/images/bingo/diagonalLine1.png";
import diagonalLine2 from "../../../assets/images/bingo/diagonalLine2.png";
import gameapart_ball from "../../../assets/images/bingo/gameapart_ball.png";
import cx from "classnames";
import _ from "lodash";

function Playing({
  current_player_board = [],
  current_number,
  previous_number,
  called_numbers,
  bingo_board,
  set_bingo_board,
  status,
  countdown,
  timed,
  handle_submit_bingo,
  set_show_bingo_board,
  gameParams,
}) {
  const playing_params = _.get(gameParams, "3_playing");
  const preplay_params = _.get(gameParams, "2_preplay");
  const timed_label = _.get(gameParams, "4_bingocalled.timed_label", "TIME TO CALL BINGO");
  const bingo_button = _.get(playing_params, "bingo_button", "BINGO!");
  const called_label = _.get(playing_params, "called_label", "CALLED NUMBERS");
  const current_label = _.get(playing_params, "current_label", "CURRENT");
  const last_label = _.get(playing_params, "last_label", "LAST");
  const get_ready = _.get(preplay_params, "get_ready", "GET READY!");
  const label = _.get(preplay_params, "label", "THE GAME IS ABOUT TO BEGIN");

  const get_colour = (index) => {
    switch (index) {
      case 0:
        return "red";
      case 1:
        return "blue";
      case 2:
        return "purple";
      case 3:
        return "orange";
      case 4:
        return "green";
      default:
        return "";
    }
  };

  const get_alphabet_from_number = (num) => {
    if (num > 0 && num <= 15) {
      return "B";
    } else if (num > 15 && num <= 30) {
      return "I";
    } else if (num > 30 && num <= 45) {
      return "N";
    } else if (num > 45 && num <= 60) {
      return "G";
    } else if (num > 60 && num <= 75) {
      return "O";
    }
  };

  const get_colour_from_number = (num) => {
    if (num > 0 && num <= 15) {
      return "red";
    } else if (num > 15 && num <= 30) {
      return "blue";
    } else if (num > 30 && num <= 45) {
      return "purple";
    } else if (num > 45 && num <= 60) {
      return "orange";
    } else if (num > 60 && num <= 75) {
      return "green";
    }
  };

  const handle_press = (i, j) => {
    if (i === 2 && j === 2) return;
    const arr = [...bingo_board];
    if (arr[i][j] === 1) {
      arr[i][j] = 0;
    } else if (arr[i][j] === 0) {
      arr[i][j] = 1;
    }
    set_bingo_board(arr);
  };

  const is_active = (i, j) => {
    if (bingo_board[i][j] === 1) {
      return "-active";
    } else {
      return "";
    }
  };

  const get_horizontal_lines = () => {
    const horizontalLinePositions = [3.5, 22, 41, 59.5, 79];
    const res = [];
    for (let j = 0; j < 5; j++) {
      let count = 0;
      for (let i = 0; i < 5; i++) {
        if (bingo_board[i][j] === 1) {
          count++;
        }
      }
      if (count === 5) {
        res.push(
          <img
            alt=""
            className="line"
            src={horizontalLine}
            style={{ top: `${horizontalLinePositions[j]}%`, width: "100%" }}
          />,
        );
      }
    }
    return res.map((item) => item);
  };

  const get_vertical_lines = () => {
    const verticalLinePositions = [2.5, 21.5, 40.5, 59.5, 78.5];
    const res = [];
    for (let i = 0; i < 5; i++) {
      let count = 0;
      for (let j = 0; j < 5; j++) {
        if (bingo_board[i][j] === 1) {
          count++;
        }
      }
      if (count === 5) {
        res.push(
          <img
            alt=""
            className="line"
            src={verticalLine}
            style={{ left: `${verticalLinePositions[i]}%`, height: "100%" }}
          />,
        );
      }
    }
    return res.map((item) => item);
  };

  const get_diagonal_lines = () => {
    const res = [];
    let count1 = 0;
    let count2 = 0;
    for (let i = 0; i < 5; i++) {
      if (bingo_board[i][i] === 1) {
        count1++;
      }
      if (bingo_board[i][4 - i] === 1) {
        count2++;
      }
    }
    if (count1 === 5) {
      res.push(<img alt="" src={diagonalLine1} className="line diagonal-left" />);
    }
    if (count2 === 5) {
      res.push(<img alt="" src={diagonalLine2} className="line diagonal-right" />);
    }
    return res.map((item) => item);
  };

  const is_disabled = () => {
    const lines = [...get_vertical_lines(), ...get_horizontal_lines(), ...get_diagonal_lines()];
    return lines.length < 1 || called_numbers.length < 4;
  };

  const submit_disabled = is_disabled();

  return (
    <div className="playing-container">
      {status === "PrePlay" ? (
        <div className="game-about-to-begin">
          <h2 className="txt">{label}</h2>
        </div>
      ) : (
        <div className="score-card">
          <div className="called-number">
            <p className="txt">{called_label}</p>
            <h5 className="num">{called_numbers?.length}</h5>
          </div>
          <div className="current">
            <p className="txt">{current_label}</p>
            <div className={`current-circle-${get_colour_from_number(current_number)}`}>
              <p className="alpha">{get_alphabet_from_number(current_number)}</p>
              <p className="num">{current_number}</p>
            </div>
          </div>
          <div className="last">
            <p className="txt">{last_label}</p>
            <div className={`last-circle-${get_colour_from_number(previous_number)}`}>
              <p className="alpha">{get_alphabet_from_number(previous_number)}</p>
              <p className="num">{previous_number}</p>
            </div>
          </div>
        </div>
      )}

      <div className="logo">
        <p className="red">B</p>
        <p className="blue">I</p>
        <p className="purple">N</p>
        <p className="orange">G</p>
        <p className="green">O</p>
      </div>
      <div className="matrix-container">
        {status === "PrePlay" && (
          <div className="get-ready">
            <h2 className="get-ready-txt">{get_ready}</h2>
          </div>
        )}
        {get_diagonal_lines()}
        {get_vertical_lines()}
        {get_horizontal_lines()}
        <div className="circle-in-column">
          {current_player_board.map((column, i) => (
            <div className={`matrix-${get_colour(i)}-container`}>
              {column.map((item, j) => (
                <div
                  className={`matrix-${get_colour(i)}${is_active(i, j)}-circle`}
                  onClick={() => handle_press(i, j)}
                >
                  {i === 2 && j === 2 ? <img src={gameapart_ball} alt="" /> : <span>{item}</span>}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
      <div className="bingo-btn-container">
        <button
          disabled={submit_disabled}
          className={cx("bingo-btn", {
            disabled: submit_disabled,
          })}
          onClick={() => {
            handle_submit_bingo();
            status === "BingoCalled" && set_show_bingo_board(false);
          }}
        >
          {bingo_button}
        </button>
        {status === "BingoCalled" && timed && (
          <h5 className="time-to-call">
            {timed_label} <p className="time-num"> {countdown}</p>
          </h5>
        )}
      </div>
    </div>
  );
}

export default Playing;
